import { render, staticRenderFns } from "./NoTaxesConfirm.vue?vue&type=template&id=449bce13&"
import script from "./NoTaxesConfirm.vue?vue&type=script&lang=js&"
export * from "./NoTaxesConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports